import { Component, Input, Output, EventEmitter } from '@angular/core';
import { getCurrencySign } from '@gs-2.0/core';

export interface FeaturedCardData {
  imageUrl: string | null;
  causeName: string | null;
  name: string | null;
  description: string | null;
  organisationName?: string | null;
  amountRaisedToDate?: number | null;
  totalProjectBudget?: number | null;
  uuid: string;
  giveLink: string;
  languageCode?: string | null;
  currencySymbol?: string | null;
  principalAmountCurrencySymbol?: string | null;
}

@Component({
  selector: 'app-featured-card',
  standalone: false,
  templateUrl: './featured-card.component.html',
  styleUrls: ['./featured-card.component.scss']
})
export class FeaturedCardComponent {
  readonly IMAGE_PLACEHOLDER = 'https://fdi-files.s3.amazonaws.com/public/image-placeholder.png';

  @Input() card!: FeaturedCardData;
  @Input() showOrgInfo: boolean = true;
  @Input() showProgress: boolean = true;
  @Input() contentHeight: number = 220; // Height of card content in pixels
  @Input() giveUrl?: string; // URL for give button/link
  @Input() learnMoreUrl?: string; // URL for learn more button/link
  @Output() giveClick = new EventEmitter<FeaturedCardData>();
  @Output() learnMoreClick = new EventEmitter<FeaturedCardData>();

  get resolvedCurrencySymbol(): string {
    if (this.card.currencySymbol) return this.card.currencySymbol;
    if (this.card.principalAmountCurrencySymbol) {
      return getCurrencySign(this.card.principalAmountCurrencySymbol, '$');
    }
    return '$';
  }

  get progressPercentage(): number {
    if (!this.card.amountRaisedToDate || !this.card.totalProjectBudget) {
      return 0;
    }
    return (this.card.amountRaisedToDate / this.card.totalProjectBudget) * 100;
  }

  onGiveClick(event?: MouseEvent): void {
    // For desktop links, prevent default if it's not a ctrl/cmd/middle click
    if (event && this.giveUrl && !event.ctrlKey && !event.metaKey && event.button !== 1) {
      event.preventDefault();
    }
    this.giveClick.emit(this.card);
  }

  onLearnMoreClick(event?: MouseEvent): void {
    // For desktop links, prevent default if it's not a ctrl/cmd/middle click
    if (event && this.learnMoreUrl && !event.ctrlKey && !event.metaKey && event.button !== 1) {
      event.preventDefault();
    }
    this.learnMoreClick.emit(this.card);
  }
}
